<template>
  <div>
    <WmsTable rowKey="logisticsCode" v-bind="$attrs" :columns="newColumns" :isExpanded_hidden="prentType != 'small'"
      @selectChange="selectChangeCall" @pageChange="pageChangeCall" :dataSource="dataSource" listener ref="wmsTable"
      :isPagination="query" :keepExpended="true" :hasHeader="false" :isRowSelection="($attrs.tableType === 'AlreadyProduced' && prentType != 'small') ||
        ($attrs.tableType === 'ToBeProduced' && prentType === 'small')
        " :preserveSelectedRowKeys="$attrs.tableType === 'ToBeProduced' && prentType === 'small'
          ">
      <div v-if="$attrs.tableType === 'AlreadyProduced'" slot="action" style="display: flex; flex-wrap: wrap"
        slot-scope="{ text, record }">
        <template v-if="prentType != 'small'">
          <div>
            <span class="span__btn" @click="() => submit('download', record)" v-if="!record.offlineFlag">下载发票</span>
            <span v-else>-</span>
          </div>
        </template>
        <template v-else>
          <div>
            <span class="span__btn" @click="smallBagDown(record)" v-if="!record.offlineFlag">下载发票</span>
            <span v-else>-</span>
            <div>
              <span class="span__btn" style="color:red;" @click="returnEdit(record)"
                v-if="!record.offlineFlag && record.invoiceType === 1">回退修改</span>
            </div>
          </div>
        </template>
        <div style="width: 100%">
          <span class="span__btn" @click="returnWaitPlay(record)"
            v-if="prentType !== 'small' && record.status === 1">退回待制作</span>
        </div>
      </div>
      <div v-else slot="action" style="display: flex; flex-wrap: wrap" slot-scope="{ text, record }">
        <span class="span__btn" @click="createGenerateSalesContract(record)"
          v-if="record.priceDeclarationType == 1">生成销售合同</span>
        <span class="span__btn" @click="toReview('make', record)">制作发票</span>
        <span class="span__btn" @click="downLoadBoxList(record)">下载装箱清单</span>
      </div>
      <template slot="logisticsCode" slot-scope="{ text, record }">
        <div>{{ text }}</div>
        <el-tag v-if="record.needRefundTaxFlag" type="warning" style="margin-right: 5px">需退税</el-tag>
        <el-tag type="warning" effect="dark" v-if="record.allIncludeFlag === 1">一价全包</el-tag>
        <el-tag type="warning" effect="dark" v-if="record.needFullDeclarationFlag === 1">全量申报</el-tag>
        <el-tag type="warning" effect="dark" v-if="record.mergeFlag === 1">合单发货</el-tag>
        <el-tag type="warning" effect="dark" v-if="record.skuQuantityExceeds === 1">sku数超限制数</el-tag>
      </template>
      <template slot="forwarder" slot-scope="{ text, record }">
        {{ record.forwarder + "-" + record.shippingType }}
      </template>
      <template slot="tax" slot-scope="{ text, record }">
        <template v-if="record.financialInstitutionCode">
          <span>口座金融機関コード：{{ record.financialInstitutionCode }}</span>
          <br />
          <span>口座支店コード：{{ record.branchCode }}</span>
          <br />
          <span>口座番号：{{ record.taxDeductionAccount }}</span>
          <br />
          <span>輸入者標準コード：{{ record.importerCode }}</span>
        </template>
        <div v-else>-</div>
      </template>
      <template slot="boxDetail" slot-scope="{ text, record }">
        <div v-if="record.boxDetail && record.boxDetail.length">
          <div v-for="(i, index) in record.boxDetail" :key="index">
            {{ `${i.length}*${i.width}*${i.height}-${i.boxNum}-${i.weight}kg` }}
          </div>
        </div>
        <div v-else>-</div>
      </template>
      <template slot="expandedRender" slot-scope="{ record, son_width, targetLeft }">
        <div class="expandedRenderBox" :style="'width:' +
          son_width +
          'px;position:relative;left:' +
          targetLeft +
          'px;overflow:hidden;z-index:99'
          ">
          <a-table bordered :columns="newColumns_son" :pagination="false" rowKey="deliveryTaskDetailId"
            :dataSource="record.skuList" :scroll="{
              x:
                columsWitchCalc(columnsSon) < son_width
                  ? son_width
                  : columsWitchCalc(columnsSon),
            }" class="son__table--customize">
            <ImgView slot="productImgAction" slot-scope="text" :src="text" width="60" height="60" />
            <template slot="shopProductSku" slot-scope="text, record">
              {{ text }}
              <el-tag v-if="record.needRefundTaxFlag" type="warning">需退税</el-tag>
            </template>
            <template #action="text, record">
              <div v-if="record.productType !== 3">
                <a @click="saveDeclarationInfo(record, 1)">维护申报信息</a>
              </div>
              <div v-if="record.productType !== 3">
                <a @click="openDeclarationCodeModal(record, 1)">新增中文品名</a>
              </div>
              <div v-if="record.productType === 3">
                <a @click="checkCombinationProduct(record)">查看子商品</a>
              </div>
            </template>
            <template slot="productSku" slot-scope="text, record">
              <div>
                <a :href="record.productLink" target="_blank" v-if="record.productLink">{{ text }}</a>
                <span v-else>{{ text }}</span>
              </div>
            </template>
          </a-table>
        </div>
      </template>
    </WmsTable>
    <el-dialog :close-on-click-modal="false" title="制作发票" :visible.sync="dialogVisible" width="30%"
      class="dialog-temp-invoice">
      <div>
        <div class="dialog-titles">收件信息</div>
        <div class="pl-150">
          <div class="dialog-content">
            <label>姓名：</label><span>{{ rowItem.name }}</span>
          </div>
          <div class="dialog-content">
            <label>联系电话：</label><span>{{ rowItem.mobile }}</span>
          </div>
          <div class="dialog-content">
            <label>公司名（会社编号）：</label><span>{{ rowItem.clubCode }}</span>
          </div>
          <div class="dialog-content">
            <label>都道府县：</label><span>{{ rowItem.province }}</span>
          </div>
          <div class="dialog-content">
            <label>市区町村：</label><span>{{ rowItem.city }}</span>
          </div>
          <div class="dialog-content">
            <label>详细地址：</label><span>{{ rowItem.address }}</span>
          </div>
          <div class="dialog-content">
            <label>邮编：</label><span>{{ rowItem.postalCode }}</span>
          </div>
        </div>
      </div>
      <div>
        <div class="dialog-titles">发票模版</div>
        <div class="pl-150 dialog-content">
          <el-radio-group v-if="invoiceTemplateList.length > 0" v-model="invoiceTemplate"
            @change="onChangeInvoiceTemplate">
            <el-radio v-for="item in invoiceTemplateList" :label="item.templateCode" :key="item.templateCode">
              {{ item.templateName }}</el-radio>
            <!-- <el-radio :label="0" >自宅</el-radio>
            <el-radio :label="1" >乐天</el-radio>
            <el-radio :label="2" >亚马逊</el-radio> -->
          </el-radio-group>
          <div v-else>暂无可用发票模版</div>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="() => submit('make', this.rowItem)">{{
          invoiceTemplateList.length <= 0 ? "已线下制作发票" : "生成发票" }}</el-button>
      </span>
    </el-dialog>
    <el-dialog :visible.sync="combinationProductVisible" width="1300px">
      <div slot="title" class="dialogTitle" style="color: #fff">查看子商品</div>
      <WmsTable :hasHeader="false" :columns="combinationColumns" :dataSource="combinationProductList" :scrollY="500"
        :isPagination="false">
        <ImgView slot="productImg" slot-scope="{ text, record, index }" :src="text" />
        <div slot="action" slot-scope="{ text, record, index }">
          <span class="span__btn" style="color: #40a9ff" @click="saveDeclarationInfo(record, 2)">
            维护申报信息
          </span>
          <div>
            <span class="span__btn" @click="openDeclarationCodeModal(record, 2)">新增中文品名</span>
          </div>
        </div>
        <div slot="productSku" slot-scope="{ text, record, index }">
          <a :href="record.productLink" target="_blank" v-if="record.productType === 1">{{ text }}</a>
          <span v-else>{{ text }}</span>
        </div>
      </WmsTable>
    </el-dialog>
    <DeclarationCodeModal ref="declarationCodeModalRef" @submit="submitDeclarationCode" />
    <EditProductCategoryZh ref="editProductCategoryZhRef" @submit="submitEditProductCategoryZh" />

    <el-dialog :visible.sync="saveDeclarationInfoVisible" width="500px" v-if="saveDeclarationInfoVisible"
      :close-on-click-modal="false" :close-on-press-escape="false">
      <div slot="title" class="dialogTitle" style="color: #fff">
        维护申报信息
      </div>
      <el-form label-width="150px" class="dialogForm" style="margin-top: 30px" :model="saveDeclarationData"
        ref="saveDeclarationDataForm" :rules="{
          productDeclarationId: [
            { required: true, message: '请选择申报品名', trigger: 'blur' },
          ],
          // compilationMethod: [
          //   {
          //     required: true,
          //     message: '请选择编制方式和材质',
          //     trigger: 'blur',
          //   },
          // ],
        }">
        <el-form-item label="申报品名" prop="productDeclarationId">
          <el-select style="float: left" placeholder="请选择申报品名" v-model="saveDeclarationData.productDeclarationId"
            filterable>
            <el-option :label="item.productItemCategoryZh" :value="item.productCustomsId" v-for="item in customsList"
              :key="item.productCustomsId"></el-option>
          </el-select>
        </el-form-item>
        <!-- <el-form-item label="编制方式和材质" prop="compilationMethod" filterable>
          <el-select style="float: left" placeholder="请选择编制方式和材质" v-model="saveDeclarationData.compilationMethod"
            filterable>
            <el-option :label="item.compilationMethod" :value="item.compilationMethod"
              v-for="item in compilationMethodList" :key="item.compilationMethod"></el-option>
          </el-select>
        </el-form-item> -->
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="saveDeclarationInfoVisible = false">取消</el-button>
        <el-button type="primary" @click="saveDeclaration">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import WmsTable from "@/components/WmsTable";
import ImgView from "@/components/ImgView";
import { Table } from "ant-design-vue";
import {
  columns,
  columnsSon,
  columns_Action,
  columns_AlreadyProduced,
  columns_small,
  columns_small_already,
} from "./InterListData";
import { combinationColumns } from "../../review/components/InterListData";
import {
  getTemplate,
  makeInvoiceCommit,
  downloadInvoice,
  generateSalesContract,
  offlineCommit,
  downloadInvoicePackingList,
  returnBackPlayApi,
  getCombinationItemListApi,
  customsPage,
  customsConfirm,
  d2cFallbackApi
} from "@/apis/outStock";
import EditProductCategoryZh from "@/views/outOfStock/review/components/EditProductCategoryZh";
import DeclarationCodeModal from "@/views/outOfStock/review/components/declarationCodeModal.vue";
export default {
  name: "InterList",
  components: {
    [Table.name]: Table,
    WmsTable,
    ImgView,
    EditProductCategoryZh,
    DeclarationCodeModal,
  },
  props: {
    prentType: {
      type: String,
    },
    layout: {
      type: String,
      default: () => {
        return "";
      },
    },
    total: {
      type: [String, Number],
    },
    dataSource: {
      type: Array,
      default: () => {
        return [];
      },
    },
    forwarder: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      combinationProductList: [],
      combinationColumns,
      combinationProductVisible: false,
      columns,
      columnsSon,
      query: this.$parent.$data.query,
      selRow: [],
      targetLeft: 0,
      dialogVisible: false,
      /** 选中的模版 */
      invoiceTemplate: undefined,
      /** 查询模版list */
      invoiceTemplateList: [],
      rowItem: {},
      query: {
        current: 1,
        pageSize: 20,
        total: 0,
      },
      reviewDialogShow: false,
      reviewData: {
        auditIntForwarderConfigId: "",
      },
      reviveForm: {
        remark: "",
      },
      skip: [],
      combineProductSku: "",
      customsList: [],
      saveDeclarationData: {},
      saveDeclarationInfoVisible: false,
    };
  },
  watch: {
    total: {
      immediate: true,
      handler: function (newVal, oldVal) {
        console.log("__________________________________________");
        console.log(newVal, oldVal);
        this.query.total = newVal;
      },
      keep: true,
    },
    dataSource: {
      immediate: true,
      handler: function (newVal, oldVal) {
        newVal.forEach((item) => {
          item.oldId = item.id;
          item.id = "review" + item.id;
        });
      },
      keep: true,
    },
  },
  computed: {
    newColumns: function () {
      let _columns = [...columns];
      if (this.$attrs.tableType === "AlreadyProduced") {
        _columns = _columns
          .concat(columns_AlreadyProduced)
          .concat(columns_Action);
      } else {
        _columns = _columns.concat(columns_Action);
        // _columns = _columns.concat(columns_waitingProduced).concat(columns_Action)
      }
      if (
        this.prentType == "small" &&
        ["ToBeProduced", "neverProduced"].includes(this.$attrs.tableType)
      ) {
        return columns_small;
      }
      if (
        this.prentType == "small" &&
        this.$attrs.tableType == "AlreadyProduced"
      ) {
        return columns_small_already;
      }
      return _columns;
    },
    newColumns_son: function () {
      let _columns = [...columnsSon];
      return _columns;
    },
  },
  methods: {
    onChangeInvoiceTemplate: function (val) {
      // console.log(999, val)
      this.invoiceTemplate = val;
    },
    downloadFile: function (res) {
      // const date = Calendar.d1(Date.now());
      let blobObj = new Blob([res.data], {
        type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
      });
      let blobUrl = window.URL.createObjectURL(blobObj);
      const link = document.createElement("a");
      link.href = blobUrl;
      let temp = res.headers["content-disposition"];
      let filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
      let matches = filenameRegex.exec(temp);
      let filename = "";
      if (matches != null && matches[1]) {
        filename = matches[1].replace(/['"]/g, "");
      }

      // const world = this.invoiceTemplate?.split('-')?.[1] || ''
      link.download = decodeURI(escape(filename));
      link.click();
      window.URL.revokeObjectURL(link.href);
    },
    submit: function (type, record) {
      const { logisticsCode, invoiceTemplateCode } = record;
      if (type == "make" && this.invoiceTemplateList.length <= 0) {
        // this.$message.warning('当前单据存在可用发票模板，请刷新页面')
        offlineCommit({ logisticsCode }).then((res) => {
          this.$message.success("成功");
          this.dialogVisible = false;
          this.$emit("refeash");
        });
        return false;
      }
      const params = {
        logisticsCode,
        // 为下载的需要添加该字段
        invoiceTemplateCode:
          type === "download" ? invoiceTemplateCode : this.invoiceTemplate,
      };
      const api =
        this.$attrs.tableType === "AlreadyProduced"
          ? downloadInvoice
          : makeInvoiceCommit;
      api(params).then((res) => {
        if (res.headers["content-type"] == "application/json") {
          let enc = new TextDecoder("utf-8");
          let data = JSON.parse(enc.decode(new Uint8Array(res.data)));

          if (!data.success) {
            this.$message.error(data.msg);
          } else {
            this.downloadFile(res);
          }
        } else {
          this.downloadFile(res);
        }
        this.dialogVisible = false;
        this.$emit("refeash");
      });
      // console.log(8888, this.invoiceTemplate)
    },
    pageChangeCall: function (payload) {
      this.query.current = payload.current;
      this.query.pageSize = payload.pageSize;
      this.$emit("pageChange", payload);
    },
    selectChangeCall: function (rows) {
      this.selRow = rows;
      this.$emit("selectChange", rows);
    },
    resetPage() {
      this.query.current = 1;
      this.$refs.wmsTable.resetSel();
    },
    //子table宽度计算
    columsWitchCalc(column) {
      let width = 0;
      column.forEach((item) => {
        width += item.width || 188;
      });
      return width;
    },
    /** 操作 */
    toReview(type, record) {
      this.rowItem = record;
      // console.log(7779, record)
      const { logisticsCode } = record || {};
      // if(type === 'make'){
      this.dialogVisible = true;
      getTemplate({ logisticsCode })
        .then((res) => {
          const data = res?.data || [];
          this.invoiceTemplateList = data || [];
          if (data?.length > 0) {
            // 默认选中第一个
            this.invoiceTemplate = data?.[0]?.templateCode;
          }
        })
        .catch(() => (this.invoiceTemplateList = []));
    },
    //生产销售合同
    createGenerateSalesContract(r) {
      generateSalesContract({ logisticsCode: r.logisticsCode }).then((res) => {
        console.log(res);
        if (res.status == 200) {
          let blobObj = new Blob([res.data], {
            type: "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
          });
          let blobUrl = window.URL.createObjectURL(blobObj);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = `${r.logisticsCode}-销售合同.doc`;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
        // if (res.headers['content-type'] == 'application/json') {
        //   let enc = new TextDecoder('utf-8')
        //   let data = JSON.parse(enc.decode(new Uint8Array(res.data)))

        //   if (!data.success) {
        //     this.$message.error(data.msg)
        //   } else {
        //     this.downloadFile(res)
        //   }
        // } else {
        //   this.downloadFile(res)
        // }
      });
    },
    downLoadBoxList(r) {
      downloadInvoicePackingList({
        logisticsCode: r.logisticsCode,
      }).then((res) => {
        if (res.status == 200) {
          let blobObj = new Blob([res.data], {
            type: "application/vnd.ms-excel;charset=UTF-8",
          });
          let blobUrl = window.URL.createObjectURL(blobObj);
          const link = document.createElement("a");
          link.href = blobUrl;
          link.download = `${r.logisticsCode}-装箱清单.xls`;
          link.click();
          window.URL.revokeObjectURL(link.href);
        }
      });
    },
    smallBagDown(r) {
      window.open(r.url);
    },
    returnWaitPlay(record) {
      this.$confirm("是否退回待制作", "提示", {
        confirmButtonText: "确认",
        type: "warning",
        cancelButtonText: "取消",
      }).then(() => {
        returnBackPlayApi({
          id: record.oldId,
        }).then((res) => {
          console.log(res);
          if (res.success) {
            this.$message.success("操作成功！");
            this.$emit("pageChange", this.query);
          }
        });
      });
    },
    openDeclarationCodeModal(record, type) {
      this.$refs.declarationCodeModalRef.open(record, type);
    },
    // 编辑中文品名

    saveDeclarationInfo(record, type) {
      if (record.productType !== 2) {
        // 普通商品走新弹窗
        this.$refs.editProductCategoryZhRef.open(
          {
            ...record,
            productItemCategoryZh: record.productCategoryName,
          },
          type
        );
        return;
      }
      // 如果是oem则走原逻辑
      this.saveDeclarationInfoVisible = true;
      let info = { ...record };
      if (
        this.customsList.every(
          (v) => v.productCustomsId != record.productDeclarationId
        )
      ) {
        info.productDeclarationId = record.productCategoryName;
      }
      this.saveDeclarationData = info;
    },
    // 查看子商品
    checkCombinationProduct(record) {
      if (record?.productSku) {
        this.combineProductSku = record.productSku;
      }
      getCombinationItemListApi({ productSku: this.combineProductSku }).then(
        ({ code, data }) => {
          if (code == 0) {
            this.combinationProductList = data;
            this.combinationProductVisible = true;
          }
        }
      );
    },
    submitDeclarationCode(record, type) {
      if (type === 2) {
        this.checkCombinationProduct();
      }
      this.$emit("refeash");
    },
    submitEditProductCategoryZh(record, type) {
      if (type === 2) {
        // 组合商品弹窗
        this.checkCombinationProduct();
      }
      this.$emit("refeash");
    },

    saveDeclaration() {
      this.$refs.saveDeclarationDataForm.validate((v, obj) => {
        if (v) {
          let targetCustom = this.customsList.filter(
            (v) =>
              v.productCustomsId ==
              this.saveDeclarationData.productDeclarationId
          )[0];
          if (!targetCustom) {
            this.$message.warning("品名失效");
            return false;
          }
          let params = {
            deliveryReviewDetailId: this.saveDeclarationData.id,
            productSku: this.saveDeclarationData.productSku,
            productDeclarationId: targetCustom.productCustomsId,
            productItemCategoryZh: targetCustom.productItemCategoryZh,
            productItemCategoryEn: targetCustom.productItemCategoryEn,
            customsCode: targetCustom.customsCode,
            // compilationMethod: this.saveDeclarationData.compilationMethod,
          };
          customsConfirm(params).then(({ code, data }) => {
            if (code == 0) {
              this.$message.success("成功");
              this.saveDeclarationInfoVisible = false;
              this.checkCombinationProduct();
              this.$emit("refeash");
            }
          });
        }
      });
      // let dataSource = [...this.dataSource]

      // let data = this.forwarder.filter(item => item.intForwarderConfigId == val)[0]
      // dataSource[index].auditIntForwarderConfigId = val
      // dataSource[index].auditShippingType = data.shippingType
      // dataSource[index].auditForwarder = data.forwarder

      // this.$emit('tableForwarderChange', dataSource)
    },
    returnEdit(record) {
      console.log(record)
      this.$confirm('是否回退修改', "提示", {
        confirmButtonText: "确认",
        type: "warning",
        cancelButtonText: "取消",
      }).then(() => {
        d2cFallbackApi({
          id: record.oldId
        }).then((res) => {
          console.log(res)
          if(!res.success) return
          this.$message.success('操作成功')
          this.$emit("refeash");
        })
      });

    }
  },
  mounted() {
    customsPage().then(({ code, data }) => {
      if (code == 0) {
        this.customsList = data;
      }
    });
  },
};
</script>

<style scoped>
.ant-table-expanded-row .son__table--customize>>>td,
.son__table--customize>>>th {
  border-right: 0px solid #e8e8e8 !important;
}

.shipmentCode__span {
  position: relative;
  top: 0;
  left: 0;
  display: block;
  line-height: 24px;
}

.shipment__error::before {
  position: absolute;
  bottom: 0;
  left: 0;
  content: "运单号获取异常";
  display: block;
  height: 24px;
  line-height: 24px;
  font-size: 12px;
  color: red;
}

.span__btn {
  cursor: pointer;
  padding: 1px 0;
  margin: 2px;
  color: #40a9ff;
}

::v-deep .headerClass {
  background-color: #ddeefe !important;
}
</style>
<style>
.dialog-temp-invoice .dialog-titles {
  font-size: 15px;
  font-weight: bold;
  text-align: left;
}

.dialog-temp-invoice .dialog-content {
  margin-bottom: 16px;
  display: flex;
}

.dialog-temp-invoice .pl-150 {
  padding-left: 100px;
}
</style>
